import { useRef, useEffect } from 'react';
import { formatDollars } from '@/utils/formatDollars';
import { flashElement } from '@/utils/animationHelpers';

interface SurchargeDeltaRowProps {
  surchargedPay: number;
  basePay: number;
  surchargeAmount: number;
}

const SurchargeDeltaRow: React.FC<SurchargeDeltaRowProps> = ({
  surchargedPay,
  basePay,
  surchargeAmount,
}) => {
  const valuesRef = useRef<HTMLDivElement>(null);
  const prevAmount = useRef<number | null>(null);

  useEffect(() => {
    if (prevAmount.current !== null && prevAmount.current !== surchargeAmount && valuesRef.current) {
      flashElement(valuesRef.current);
    }
    prevAmount.current = surchargeAmount;
  }, [surchargeAmount]);

  return (
    <div className="flex items-center justify-between gap-2 px-2 py-2 bg-primary/[0.08] border border-primary/20 rounded-[0.25rem]">
      <span
        className="font-label text-[10px] sm:text-[12px] font-medium shrink-0"
        style={{ color: 'var(--primary-text)' }}
      >
        Surcharge
      </span>
      <div
        ref={valuesRef}
        className="flex items-center gap-2 min-w-0"
      >
        <span
          className="font-mono text-[10px] sm:text-[12px]"
          style={{ color: 'color-mix(in oklab, var(--primary-text) 75%, transparent)' }}
        >
          {formatDollars(surchargedPay)} &minus; {formatDollars(basePay)}
        </span>
        <span
          className="font-mono text-[10px] sm:text-[12px] font-bold tabular-nums"
          style={{ color: 'var(--primary-text)' }}
        >
          +{formatDollars(surchargeAmount)}
        </span>
      </div>
    </div>
  );
};

export { SurchargeDeltaRow };
export type { SurchargeDeltaRowProps };
